import {PureComponent} from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import FileUpload from '@material-ui/icons/CloudUpload'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import TextField from '@material-ui/core/TextField'
import {Editor} from '@tinymce/tinymce-react'

import getString from "../config/strings";
import {showAlert} from "./alert/alert";
import {validateAuth} from "../services/oauthService";

import ApiService from "../services/dataService";

class DocumentUploadDialog extends PureComponent {

    constructor(props, context, updater) {
        super(props, context, updater)
        this.state = {
            actRecord: {...props.record},
            uploadProgress: false
        }
        this.state.initialDescription = this.state.actRecord.description
    }

    handleSave(event) {
        const {saveFunc} = this.props
        const {actRecord} = this.state
        event.preventDefault()
        saveFunc(actRecord)
    }

    changeField(fieldName, value) {
        const {actRecord} = this.state
        const newRecord = {...actRecord}
        newRecord[fieldName] = (value || '').replace(/^\s+/, '')
        this.setState({actRecord: newRecord})
    }

    async uploadDocument(event) {
        const {uploadProgress} = this.state
        if (uploadProgress) return

        const fileinput = event.target
        if (fileinput.files.length <= 0 || !fileinput.files[0].name) return

        const {auth, parent} = this.props
        const {actRecord} = this.state

        this.setState({uploadProgress: true})

        try {
            const newAuth = validateAuth(auth)
            if (newAuth === null) {
                parent.setLogin(null)
                return
            }

            const data = await ApiService.uploadFile(fileinput.form, newAuth.access_token)
            if (data.relativePath) {
                const newRecord = {...actRecord}
                newRecord.filepath = data.relativePath
                if (!newRecord.title) newRecord.title = data.relativePath
                this.setState({actRecord: newRecord, uploadProgress: false})
            }

        } catch (error) {
            this.setState({uploadProgress: false})
            console.error('ERROR', 'fileupload failed', error)
            showAlert(getString(error.message), getString('ERROR_HEADLINE'))
        }
    }

    render() {
        const {closeFunc, action, title} = this.props
        const {actRecord, uploadProgress, initialDescription} = this.state

        return (<div>
            <Dialog
                open={true}
                aria-labelledby="form-dialog-title"
                maxWidth={false}
                disableEnforceFocus={true}
            >
                <DialogTitle id="form-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    <form method="POST"
                          encType="multipart/form-data"
                          onSubmit={(event) => event.preventDefault()}>
                        <Button component='span' variant="contained" size="small" color="primary"
                                disabled={uploadProgress}
                                onClick={(event) => {
                                    event.target.querySelector('input').click()
                                }}>
                            <FileUpload style={{marginRight: 12}}/>
                            {getString('UPLOAD_DOCUMENT')}
                            <input type="file" name="file" accept=".pdf,application/pdf"
                                   className="fileUploadButton"
                                   onClick={(event) =>
                                       event.stopPropagation()
                                   }
                                   onChange={(event) =>
                                       this.uploadDocument(event).then(null).catch(console.error)
                                   }/>
                            {uploadProgress && <CircularProgress color="secondary"
                                                                 style={{
                                                                     position: 'absolute',
                                                                     left: '50%',
                                                                     top: '50%',
                                                                     transform: 'translate(-50%,-50%)'
                                                                 }}/>}
                        </Button>
                    </form>

                    <TextField
                        autoFocus
                        margin="normal"
                        id="document_title"
                        name="document_title"
                        label={getString('DOCUMENT_TITLE')}
                        required={true}
                        type="text"
                        onChange={(event) => {
                            this.changeField('title', event.target.value)
                        }}
                        value={actRecord.title}
                        fullWidth
                    />
                    <FormControl component="fieldset" style={{display: 'block'}}>
                        <FormLabel component="legend"
                                   style={{padding: '12px 0 12px 0'}}>{getString('DOCUMENT_DESCRIPTION')}</FormLabel>
                        <Editor
                            id="document_description"
                            name="document_description"
                            initialValue={initialDescription}
                            init={{
                                plugins: 'paste hr lists preview',
                                branding: false,
                                menubar: false,
                                resize: 'both',
                                theme: 'modern',
                                min_height: 240,
                                paste_data_images: false,
                                paste_word_valid_elements: 'b,strong,i,em,p,ul,li,ol,br',
                                paste_preprocess: function (plugin, args) {
                                    args.content = args.content.replace(/<\/?(div|h1|h2|h3|h4|h5|span|font)[^>]*>/gi, '')
                                },
                                block_formats: 'Absatz=p',
                                toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist hr | outdent indent | preview',
                                content_css: 'stylesheets/ccards_content.css',
                                entity_encoding: 'raw'
                            }}
                            onEditorChange={(text, _editor) => {
                                this.changeField('description', text)
                            }}
                        />
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeFunc} color="secondary">
                        {getString('CANCEL')}
                    </Button>
                    <Button variant="contained" size="small" color="primary"
                            onClick={(event) => this.handleSave(event)}>
                        {action}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>)
    }
}

DocumentUploadDialog.propTypes = {
    auth: PropTypes.object.isRequired,
    parent: PropTypes.object.isRequired,
    record: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    saveFunc: PropTypes.func.isRequired,
    closeFunc: PropTypes.func.isRequired
}

export default DocumentUploadDialog